enum AddressbookActions {
    FETCH_LIST = "addressbookFetchList",
    GET_ITEM = "addressbookGetItem",
    CREATE_ITEM = "addressbookCreateItem",
    UPDATE_ITEM = "addressbookUpdateItem",
    DELETE_ITEM = "addressbookDeleteItem",
    REFRESH_LIST = "addressbookRefreshList",
    FETCH_TYPES = "addressbookFetchTypes",
    FETCH_COUNTRIES = "addressbookFetchCountries",
    CREATE_TYPE = "addressbookCreateType",
    UPDATE_TYPE = "addressbookUpdateType",
    DELETE_TYPE = "addressbookDeleteType",
    TRAINER_GET_PARTNER = "addressbookTrainerGetPartner",
    TRAINER_GET_PARTNER_BY_ADDRESSBOOK = "addressbookTrainerGetPartnerByAddressbook",
    TRAINER_CREATE_LOGIN = "addressbookTrainerCreateLogin",
    TRAINER_SEND_LOGIN = "addressbookTrainerSendLogin",
    TRAINER_DISABLE_LOGIN = "addressbookTrainerDisableLogin",
    TRAINER_ENABLE_LOGIN = "addressbookTrainerEnableLogin",
    TRAINER_REMOVE_LOGIN = "addressbookTrainerRemoveLogin",
    TRAINER_UPDATE_PARTNER = "addressbookTrainerUpdatePartner",
}

enum AddressbookMutation {
    SET_RENDER_UPDATE = "addressbookListRenderNeeded",
    SET_LIST_RESULT = "addressbookListResult",
    SET_TYPES = "addressbookSetTypes",
    SET_COUNTRIES = "addressbookSetCountries",
}

export {AddressbookActions, AddressbookMutation};
